import { render, staticRenderFns } from "./Skip.vue?vue&type=template&id=4860a6cc&scoped=true&"
import script from "./Skip.vue?vue&type=script&lang=js&"
export * from "./Skip.vue?vue&type=script&lang=js&"
import style0 from "./Skip.vue?vue&type=style&index=0&id=4860a6cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4860a6cc",
  null
  
)

export default component.exports